import { createApp } from 'vue'
import App from './App.vue'
import router from './router'; // Import the router configuration
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/main.css'

createApp(App)
  .use(router) // Use the router in your Vue app
  .mount('#app');

